/**
 * The administrators of the Organisation this window administers
 * (docs/adr/39-two-admin-clients-the-elaso-instance-admin-client-and-the-organisation-admin-client.md).
 * A thin wrapper: the page is `components/organization/organization-administrators.tsx`.
 */
import { createFileRoute } from "@tanstack/react-router";
import { useAdministeredOrganization } from "@/components/organization/administered-organization";
import { OrganizationAdministrators } from "@/components/organization/organization-administrators";

export const Route = createFileRoute(
	"/organization/$organizationId/administrators"
)({
	component: OrganizationAdministratorsPage,
});

function OrganizationAdministratorsPage() {
	const organization = useAdministeredOrganization();
	return (
		<div className="flex flex-col items-center gap-4 p-4 md:p-8">
			<OrganizationAdministrators
				key={organization.organizationId}
				organization={organization}
			/>
		</div>
	);
}
